import { JOB_SELECTED } from '../types';

const currentJobReducer = (state = '', action) => {
  switch (action.type) {
    case JOB_SELECTED:
      return action.payload;
    default:
      return state;
  }
};

export default currentJobReducer;



// WEBPACK FOOTER //
// ./src/reducers/currentJobIdReducer.js